import { useIsPhoneViewport } from '../../hooks/useMediaQuery';
import { useInboxUIStore } from '../../stores/inboxUIStore';

/**
 * Resolves which Inbox layout to render. A stored preference always wins;
 * without one the viewport decides, so the first visit on a phone opens in
 * mobile view and the first visit on a desktop does not.
 */
export function useInboxMobileView() {
  const storedIsMobileView = useInboxUIStore((state) => state.isMobileView);
  const setIsMobileView = useInboxUIStore((state) => state.setIsMobileView);
  const isPhoneViewport = useIsPhoneViewport();

  return {
    isMobileView: storedIsMobileView ?? isPhoneViewport,
    setIsMobileView,
  };
}
